import { isEmpty } from "lodash";
export var showFilterTags = function (tags) {
    return !isEmpty(tags) && tags.length > 1;
};
